var _style, _path, _path2, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFintechLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#0A5B91;}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -21.8001,
    y1: -330,
    x2: 131.8577,
    y2: -330,
    gradientTransform: "matrix(1 0 0 -1 0 -74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    style: {
      stopColor: "#0A5B91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24A0C7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.9,250.4l-7.8-13.5c-12.6-21.7-25-43.3-37.6-65.1c-2.4-4-4.7-5.5-9.5-5.5c-10.4-0.1-21.1-0.1-31.4-0.1 c-9.3,0-18.6,0-27.8,0c-4.5,0-9.1,0-13.6,0c-5.9,0-11.9,0-17.7,0.1c-2.6,0-4.4,0.4-6,1.5l24.2,41.5c0.8-0.5,1.7-0.7,3.1-0.8 c3.1,0,6.2-0.1,9.4-0.1c2.4,0,4.8,0,7.2,0c4.9,0,9.8,0,14.7,0c5.5,0,11.1,0,16.6,0c2.5,0,3.7,0.8,5,2.9 c6.7,11.5,13.2,22.9,19.9,34.4l4.1,7.1c1.3,2.3,1.3,3.6-0.1,6c-8,13.8-15.8,27.4-23.8,41.2c-1.4,2.4-2.7,3.2-5.7,3.2h-4.8 c-14.1,0-28.6,0.1-42.9,0c-1.3,0-2.3-0.2-3.1-0.8L59.1,344c1.5,1.1,3.2,1.6,5.7,1.6c27.1,0.2,54.6,0.1,81.2,0.1h9.1 c5.5,0,8.1-1.4,10.7-6c15-26,29.9-52,45-78C213.3,257.4,213.3,254.7,210.9,250.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.6,211.2c7.2,13,15.5,26.6,24.3,42.3c1.1,2,1.1,3.2,0,5.1c-5.5,9.5-11,19.1-16.4,28.4 c-2.6,4.5-5.4,8.8-7.8,13.4c-1.5,2.8-0.4,4.8-0.4,4.8l22.8,38.9c1.3-0.9,2.4-2.2,3.5-4c4.9-8.5,9.8-16.9,14.7-25.4 c10.3-17.6,20.7-35.8,31-53.8c2.1-3.6,2.1-6-0.1-9.7c-16.9-29.6-32-55.7-46.2-79.9c-0.9-1.4-1.7-2.5-2.7-3.3L36.5,207 C36.5,207,35.3,208.8,36.6,211.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.7931,
    y1: -331.0655,
    x2: 255.9592,
    y2: -329.1159,
    gradientTransform: "matrix(1 0 0 -1 0 -74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2547,
    style: {
      stopColor: "#24A0C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6101,
    style: {
      stopColor: "#88C3E4"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.3,211.3c7.2,13,15.5,26.6,24.3,42.3c1.1,2,1,3.2-0.1,5c-5.5,9.5-10.8,18.9-16.3,28.3 c-2.6,4.5-5.4,9.2-7.9,13.6c-1.5,2.8-0.4,4.8-0.4,4.8l22.8,38.9c1.3-0.9,2.5-2.1,3.6-3.9c1.5-2.6,3.1-5.2,4.5-7.8 c1.4-2.4,2.8-4.8,4.1-7.3c2-3.4,3.8-6.8,5.8-10c0.1-0.1,0.1-0.2,0.2-0.3c10.3-17.6,20.7-35.8,31-53.8c2.1-3.6,2.2-6.1,0.1-9.8 c-0.9-1.4-1.7-3.1-2.6-4.5c-15.9-27.7-30-52.3-43.6-75.3c-0.9-1.4-1.9-2.6-2.9-3.4l-22.9,39.2C139.3,207.2,138,208.9,139.3,211.3z "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258,183.7h10.6v67.6H258V183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.3,183.7h16.8c10.6,0,15.8,5.9,15.8,16.7v34.2c0,10.8-5.2,16.7-15.8,16.7h-16.8V183.7L276.3,183.7z  M286.9,193.3v48.3h6c3.4,0,5.4-1.7,5.4-6.6v-35c0-4.8-2.1-6.6-5.4-6.6L286.9,193.3L286.9,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330,182.9c10.4,0,15.6,6.2,15.6,17v2.1h-9.9v-2.8c0-4.8-2-6.7-5.4-6.7s-5.4,1.9-5.4,6.7 c0,13.9,20.7,16.5,20.7,35.8c0,10.8-5.4,17-15.8,17c-10.5,0-15.8-6.2-15.8-17v-4.1h10v4.8c0,4.8,2.1,6.6,5.5,6.6s5.5-1.7,5.5-6.6 c0-13.9-20.7-16.5-20.7-35.8C314.3,189.2,319.7,182.9,330,182.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.9,294.2v4h-17.5v30.6H258v-67.5h25.7v4h-21.2v28.8H279.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.9,261.3v67.6h-4.5v-67.6H294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.7,328.9h-4v-67.6h5.8l20.3,57v-57h4v67.6h-4.9l-21.2-60.2V328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352,328.9v-63.5h-13.8v-4h31.9v4h-13.6v63.4L352,328.9L352,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.9,292.6v4h-18.5v28.2h22.2v4h-26.6v-67.5h26.6v4h-22.2v27.2H398.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.6,277.8v5.6h-4.3v-5.9c0-7.2-2.8-12.8-10.3-12.8s-10.3,5.5-10.3,12.8v35.2c0,7.2,2.8,12.7,10.3,12.7 s10.3-5.4,10.3-12.7v-8h4.3v7.8c0,9.7-4.3,17-14.5,17s-14.5-7.3-14.5-17v-34.5c0-9.7,4.3-17,14.5-17S438.6,268.1,438.6,277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.3,297.2v31.8h-4.4v-67.6h4.5v31.8h21.1v-31.8h4.6v67.6h-4.6v-31.8H450.3L450.3,297.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintechLogo);
export default __webpack_public_path__ + "static/media/fintech-logo.904bbdf81e7ed4e4e8c887eec77930d0.svg";
export { ForwardRef as ReactComponent };